export default "__VITE_ASSET__CpeSDGOR__"